import { createFileRoute } from '@tanstack/react-router'
import { RunsList } from '@/features/runs/list'

export const Route = createFileRoute('/runs/')({
  component: RunsList,
})
